// extracted by mini-css-extract-plugin
export default {"dropdown":"Dropdown_dropdown__cFd62","drops":"Dropdown_drops__qiNoz","links":"Dropdown_links__x57OP"};